import { useEffect, useState } from "react";

/** One loader for the staff tabs: the data, the last error, and a reload; re-runs when `deps` change. */
export function useStaffData<T>(load: () => Promise<T>, onError: (err: unknown) => void, deps: unknown[]) {
  const [data, setData] = useState<T | undefined>(undefined);
  const [error, setError] = useState<string | null>(null);
  const [tick, setTick] = useState(0);
  useEffect(() => {
    let alive = true;
    load()
      .then((d) => {
        if (!alive) return;
        setData(d);
        setError(null);
      })
      .catch((err: unknown) => {
        if (!alive) return;
        onError(err);
        setError(err instanceof Error ? err.message : "failed");
      });
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tick, ...deps]);
  return { data, error, reload: () => setTick((n) => n + 1) };
}
